import {MagnifyingGlassIcon} from '../../../common';
import {Icon} from '@wordpress/components';
import {Button,Box} from '@lapilli-ui/components';
const Submit = ({submitStyle, buttonLabel, iconType, onClick, wrapperStyle}) =>{
  switch (submitStyle) {
    case 'text':
      return <Button className="ywcas-submit-button" color="secondary" size="sm" onClick={onClick}>{buttonLabel}</Button>;
    case 'icon':
      return iconType === 'icon-right' && <Box className="ywcas-submit-wrapper" sx={wrapperStyle}><Icon className="ywcas-submit-icon" onClick={onClick} icon={MagnifyingGlassIcon()}/></Box>;
    case 'iconText':
      return <Button className="ywcas-submit-button" color="secondary" size="sm" onClick={onClick}><Icon className="ywcas-submit-icon" icon={MagnifyingGlassIcon()}/> {buttonLabel}</Button>;
  }

}

export default Submit;